<select id="selected-mortician" class="form-control form-control-lg"  name="selected-mortician"
        [(ngModel)]="selectedMortician">
  <option value="">- alle Bestatter -</option>
  <option *ngFor="let mortician of selectableMorticians" value="{{mortician}}">{{mortician}}</option>
